import React, {useState, useEffect} from 'react'
import { TrendingUp, Info, CalendarClock } from 'lucide-react'
import { useParams} from 'react-router-dom'
import './cardcss.css'
export const IngresoCard = ({
	fontColor,
	bgColor,
	// error = null,
	// error1 = null,
	// error2 = null,
	// error3 = null,
	sku,
	descripcion, 
	roi,
	precioLista,
	mgIncrementalPorcentaje,
	mgIncrementalDinero,
	mecanica,
	descuento,
	uplift,
	mensaje,
	simulado,
	item, upliftPorcentual
	, margenPromocion, margenComercial, margenComercialIncremental, margenComercialIncrementalPorcentaje
	, estadoProducto = null, 
	viewPage,
	setModalProduct, 
	setDataProduct,
	setRejectReasonProduct
}) => {
	const [error, setError] = useState(false);
	const [error1, setError1] = useState(false);
	const [error2, setError2] = useState(false);
	const [error3, setError3] = useState(false);
	const { idPromocion , estadoPromocion} = useParams()
	const [estadoActual, setEstadoActual] = useState(estadoProducto && estadoProducto.accion)
	const [productos, setProductos] = useState([]);
	const [clickHere, setClickHere] = useState(false)
	const isViewMode = String(viewPage) === '1'
	const rol = localStorage.getItem('rol')
	const estadoPromocionNum = Number(estadoPromocion)
	const isNegotiationState = estadoPromocionNum === 9
	const rejectActionLabel = isNegotiationState ? 'Sin Acuerdo' : 'Rechazar producto'
	const canApproveOrRejectProduct =
		!isViewMode &&
		(((estadoPromocion === '5' || estadoPromocion === '7') &&
			(rol === 'ADMIN' || rol === 'SUPER ADMIN' || rol === 'APROBADOR')) ||
		(isNegotiationState &&
			(rol === 'ADMIN' || rol === 'SUPER ADMIN' || rol === 'KAM' || rol === 'KAS')))

	console.log("Contenido Item::::: ");
	console.log(item)
	console.log(estadoProducto)

	useEffect(() => {
		if(simulado === 0 || item.bajo_costo === -1){
			setError(true);
			setError3(true);
		}

		if(item.faltan_datos === 1){
			setError(true);
			setError2(true);
		}

		if(item.bajo_costo === 1){
			setError(true);
			setError1(true);
		}
	}, []);

	const actualizarProductos = () => {
		const gestionProductos = localStorage.getItem('gestionProductos');
		// alert(gestionProductos)
		if (gestionProductos) {
		  setProductos(JSON.parse(gestionProductos));
		} else {
		  setProductos([]);
		}
	};

	const productoExiste = (idProducto_) => {
		return productos.filter(producto => producto.id_producto === idProducto_)[0];
	}

	useEffect(() => {
		// Inicialmente obtener los productos
		// alert("nocorre")
		actualizarProductos();
		const producto = productoExiste(item.id_producto);
		console.log("Producto:::::::::::::::::::::Seleccionado A Cambiar:::::::")
		console.log(producto)
		if (producto && !clickHere) {
			if (producto.accion === 'aprobado') {
				// alert("aprobado")
				setEstadoActual("aprobado")
			} else if (producto.accion === 'rechazado') {
				// alert("rechazado")
				setEstadoActual("rechazado")
			} /* else if (producto.accion === 'cambio') {
				setEstadoProducto_(-1)
			} */
		}
		setClickHere(false)
		window.addEventListener("storage", actualizarProductos);
		return () => {
			// Remove the handler when the component unmounts
			window.removeEventListener("storage", actualizarProductos);
		};
	  }, [localStorage.getItem('gestionProductos')]);

	const gestionarProducto = (e, estado) => {
		const prevGestionProductos = localStorage.getItem('gestionProductos');
		let gestionProductos = prevGestionProductos ? JSON.parse(prevGestionProductos) : [];
		gestionProductos = gestionProductos.filter(producto => producto.id_producto !== item.id_producto);

		if (!estado) {
			localStorage.setItem('gestionProductos', JSON.stringify(gestionProductos));
			window.dispatchEvent(new Event("storage"));
			return;
		}

		gestionProductos.push({
							'id_promocion': idPromocion,
							'id_producto': item.id_producto,// keyId,
							'accion': estado
						});

						localStorage.setItem('gestionProductos', JSON.stringify(gestionProductos));
						window.dispatchEvent(new Event("storage"));
	}

	const openRejectReasonModal = () => {
		if (setRejectReasonProduct) {
			setRejectReasonProduct({
				codigo_producto: sku,
				descripcion,
			})
		}
	}

	return (
		<div className='IngresoCardWrapper'>
		
		{canApproveOrRejectProduct && ( <>
			<div className={(estadoActual === "aprobado" || (estadoProducto && estadoProducto.accion==="aprobado")) ? 'pen-wrapper2-aprobar-activo' : 'pen-wrapper2-aprobar'}>
				<button
					type='button'
					className='simulation-card-action-button'
					title='Aprobar producto'
					aria-label='Aprobar producto'
					onClick={(e) => {
						setClickHere(true)
						if (estadoActual === "aprobado" || (estadoProducto && estadoProducto.accion === "aprobado")) {
							if(estadoProducto){estadoProducto.accion = null}
							setEstadoActual(null)
							gestionarProducto(e, null)
							return
						}
						if(estadoProducto){estadoProducto.accion = "aprobado"}
						setEstadoActual("aprobado")
						gestionarProducto(e, 'aprobado')
					}}
				>
					✓
				</button>
			</div>
			<div className={(estadoActual === "rechazado" || (estadoProducto && estadoProducto.accion==="rechazado")) 
							? 'pen-wrapper3-rechazar-activo' : 'pen-wrapper3-rechazar'}>
				<button
					type='button'
					className='simulation-card-action-button'
					title={rejectActionLabel}
					aria-label={rejectActionLabel}
					onClick={(e) => {
						setClickHere(true)
						if (estadoActual === "rechazado" || (estadoProducto && estadoProducto.accion === "rechazado")) {
							if(estadoProducto){estadoProducto.accion = null}
							setEstadoActual(null)
							gestionarProducto(e, null)
							return
						}
						if(estadoProducto){estadoProducto.accion = "rechazado"}
						setEstadoActual("rechazado")
						gestionarProducto(e, 'rechazado')
						openRejectReasonModal()
					}}
				>
					×
				</button>
			</div>
			</>
			)}
		{ /*
			<div className='editor-hover'>
				<p>Aprobar Producto</p>

				<svg
					width='8'
					height='16'
					viewBox='0 0 8 16'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M7.76471 7.28292C8.07843 7.60162 8.07843 8.39838 7.76471 8.71708L0.705882 15.8878C0.392156 16.2065 -6.90997e-07 15.8082 -6.63135e-07 15.1708L-3.62473e-08 0.829242C-8.38568e-09 0.191842 0.392157 -0.206533 0.705883 0.112167L7.76471 7.28292Z'
						fill='#3676F5'
					/>
				</svg>
			</div>
			*/ }
	 
			<div
				className='IngresoCard'
				onMouseEnter={(e) => {
					if (e.target.classList[0] === 'IngresoCard') {
						e.target.style.borderColor = fontColor
					} else {
						e.target.closest('.IngresoCard').style.borderColor = fontColor
					}
				}}
				onMouseLeave={(e) => {
					if (e.target.classList[0] === 'IngresoCard') {
						e.target.style.borderColor = 'transparent'
					} else {
						e.target.closest('.IngresoCard').style.borderColor = 'transparent'
					}
				}}
			>
				<span className="tooltiptext2">{item.tipo_promocion.split('-')[0][0]}{item.tipo_promocion.split('-')[1][0]}</span>
				<div className='row-wrapper'>


					

			
					<div className='col'>
					
						<div>
							<a style={{cursor: "pointer"}}
								onClick={(e) => {
									setDataProduct({
										"codigo_producto": sku,
										"descripcion" : descripcion,
									})
									setModalProduct(true)
								}}
							>{sku}</a>
						</div>
						<div>
							<p>{descripcion}<br></br>
							
							</p>
							
						</div>
						<div>
							<p>
								Pre. Lista <span>{precioLista}</span>
							</p>
						</div>
						<div>
							<p>
								% Dcto. <span>{descuento}%</span>
							</p>
						</div>
						<div>
							<p>
								Mecánica <span>{mecanica}</span>
							</p>
						</div>
					</div>
					<div
						className='col'
						style={{background: bgColor, borderColor: fontColor}}
					>
						<div style={{borderColor: fontColor}}>
								<div className='error-arrow-wrapper'>

								
									{error1 && (
										<>
											<div className='error-arrow arrow-first'>
												<TrendingUp size={11} color='#FF5334' />

												<div className='error-hover-state'>
													<p>Bajo el Costo</p>
													<svg
														width='17'
														height='8'
														viewBox='0 0 17 8'
														fill='none'
														xmlns='http://www.w3.org/2000/svg'
													>
														<path
															d='M8.86632 7.40838C8.83899 7.43528 8.71392 7.5 8.5 7.5C8.28608 7.5 8.16101 7.43528 8.13369 7.40838L1.13583 0.519758C1.19042 0.507766 1.25531 0.500001 1.32924 0.500001L15.6708 0.5C15.7447 0.5 15.8096 0.507766 15.8642 0.519757L8.86632 7.40838Z'
															fill='#FF5334'
															stroke='#FF5334'
															strokeMiterlimit='1.78922'
														/>
													</svg>
												</div>
											</div>
										</>
									)}

									{error2 && (
										<>
											<div className='error-arrow'>
												<Info size={12} color='#FF5334' />
												<div className='error-hover-state'
												>
													<p>Faltan Datos</p>
													<svg
														width='17'
														height='8'
														viewBox='0 0 17 8'
														fill='none'
														xmlns='http://www.w3.org/2000/svg'
													>
														<path
															d='M8.86632 7.40838C8.83899 7.43528 8.71392 7.5 8.5 7.5C8.28608 7.5 8.16101 7.43528 8.13369 7.40838L1.13583 0.519758C1.19042 0.507766 1.25531 0.500001 1.32924 0.500001L15.6708 0.5C15.7447 0.5 15.8096 0.507766 15.8642 0.519757L8.86632 7.40838Z'
															fill='#FF5334'
															stroke='#FF5334'
															strokeMiterlimit='1.78922'
														/>
													</svg>
												</div>
											</div>
										</>
									)}
									{error3 && (
										<> 
											<div className='error-arrow '>

												<CalendarClock size={12} color='#FF5334' />
												<div className='error-hover-state'>
													<p>Sin Historia</p>
													<svg
														width='17'
														height='8'
														viewBox='0 0 17 8'
														fill='none'
														xmlns='http://www.w3.org/2000/svg'
													>
														<path
															d='M8.86632 7.40838C8.83899 7.43528 8.71392 7.5 8.5 7.5C8.28608 7.5 8.16101 7.43528 8.13369 7.40838L1.13583 0.519758C1.19042 0.507766 1.25531 0.500001 1.32924 0.500001L15.6708 0.5C15.7447 0.5 15.8096 0.507766 15.8642 0.519757L8.86632 7.40838Z'
															fill='#FF5334'
															stroke='#FF5334'
															strokeMiterlimit='1.78922'
														/>
													</svg>
												</div>
											</div>
										</>
									)}
								</div>
							<p>
							Uplift (Und.) <br /> <span>{uplift}</span>
							</p>
						</div>
						<div style={{borderColor: fontColor}}>
							<p>
								Uplift (%) <br /> <span>{upliftPorcentual}</span>
							</p>
						</div>
						<div style={{borderColor: fontColor}}>
							<p>
								Mg. Promocional. <br /> <span>{margenComercial}</span>
							</p>
						</div>
						<div style={{borderColor: fontColor}}>
							
							<p>
								
								ROI <br /> <span>{roi}</span>
							</p>
							 
							{ /* <p>
								
								Mg. Comercial Incr. <br /> <span>{margenComercialIncremental}</span>
							</p> */ }
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
